import { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { fetchLeaveMasterDropdown } from "services/employeeLeave";

const EmployeeLeaveDropdown = ({ errors, control, setValue, watch, rowData, onChange }) => {
  const selectedEmployeeId = watch("leave_id");

  const {
    data: employees,
    isLoading,
    error,
  } = useQuery(["leave-master-dropdown"], fetchLeaveMasterDropdown, {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const modifiedData = useMemo(() => {
    const leaveList = Array.isArray(employees?.data?.data)
      ? employees.data.data
      : Array.isArray(employees?.data)
        ? employees.data
        : [];

    return leaveList.map((ele) => ({
        value: ele?.leave_id ?? ele?.id,
        label: (ele?.abbr || ele?.abbreviation)
          ? `${ele.leave_name} (${ele?.abbr || ele?.abbreviation})`
          : ele?.leave_name,
      }));
  }, [employees]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options?.find((option) => String(option?.value) === String(selectedEmployeeId || rowData?.leave_id)) ||
      null
    );
  }, [options, selectedEmployeeId, rowData?.leave_id]);

  useEffect(() => {
    if (rowData?.leave_id && options?.length) {
      setValue("leave_id", rowData.leave_id);
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading leave types</div>;

  return (
    <Controller
      name="leave_id"
      control={control}
      rules={{ required: "Leave is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Leave"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption?.value : "";
            field.onChange(value);
            setValue("leave_id", value);
            if (onChange) {
              onChange(selectedOption);
            }
          }}
          className={`react-select-container ${errors?.leave_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default EmployeeLeaveDropdown;
